import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { HeaderBasket } from './../header-basket';
import { MenuServiceInt } from '@core/_services/menu.serviceint';
import { MessagesService } from '@core/_services/messages.service';
import { CommonService } from '@service/common.service';
import { ApiV6Service } from '@service/apiv6.service';
import { lastValueFrom } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-edit-basket',
    templateUrl: './edit-basket.component.html',
    styleUrls: ['./edit-basket.component.scss'],
})
export class EditBasketComponent implements OnInit {
    public dataItem: HeaderBasket;
    public resultResult: any[];

    @Input()
    public item: any;

    @Input()
    public bskType = null;

    @Input()
    public groupList = [];

    @Input()
    public userList = [];

    @Input()
    public duplicate : boolean = false;

    @Input()
    public basketList = [];

    @Output() 
    public onCancel: EventEmitter<any> = new EventEmitter();

    @Output()
    public onValidate: EventEmitter<any> = new EventEmitter();

    @Output()
    public onDeleteItem: EventEmitter<any> = new EventEmitter();
    
    @Output()
    public onLoadItem: EventEmitter<any> = new EventEmitter();


    constructor(
        private api: ApiV6Service,
        protected _messageService: MessagesService,
        public menu: MenuServiceInt,
        private commonService: CommonService,
        private translate: TranslateService,
    ) {
        this.menu.display = true;
        this.dataItem = new HeaderBasket();
    }

    ngOnInit() {
        this.getData(this.item);
        this.commonService.checkReset();
    }

    private getData(item) {
        try {
            this.dataItem.Clear();
            if (item.id !== 0) {
                this.loadData(this.basketList[item.id - 1]);
            }            
        } catch (error) {
            console.log('Error', error);
            this._messageService.addErrorMsg(this.translate.instant('Load_Data_KO'));
        }
    }

    private loadData(adata) {
        this.dataItem.duplicate = this.duplicate;
        this.dataItem.loadData(adata);
        this.onLoadItem.emit({ index: this.item.index, id: this.item.id });
    }

    delete(data) {
        data.name = this.dataItem.name;
        this.onDeleteItem.emit({ index: this.item.index, id: this.item.id, data: data });
    }

    public async validate(data) {
        let wRes: any;
        if (this.dataItem.duplicate === true) {
            // id de la requête forcé à 0 : duplication
            data.id = 0;
            data.data.id = 0;
            data.bsksrc = this.item.reference;
        } else {
            data.id = -1;
        }
        data.bskType = this.bskType;
        try {
            wRes = await lastValueFrom(this.api.execUrlAction('setbasketdata', data ));
            this.onValidate.emit({ index: this.item.index, id: this.item.id, data: wRes, duplicate: this.dataItem.duplicate });
        } catch (error) {
            if (error.error.Message === 'Exist') {
                this._messageService.addWarn(this.translate.instant('Cfb_BasketEqual'));
            } else {
                console.log('Error', error);
                this._messageService.addErrorMsg(this.translate.instant('Update_KO'));
            }
        }
    }

    cancel(event) {
        this.onCancel.emit({ index: this.item.index, id: this.item.id });
    }
}
